/**
 * Check the service worker registration status
 * @returns {ServiceWorker}  Registered service worker
 */
export async function checkServiceWorkerRegistration() {

	let result;

	if ('serviceWorker' in navigator) {
		try {
			result = await navigator.serviceWorker.getRegistration();
		} catch (error) {
			console.error(error.message);
		}
	}

	return result;

}

/**
 * Registers a service worker
 * @param {string} path            Path for the service worker to register
 * @param {Object} options         An object containing options to pass to the registration
 * @param {string} options.scope   URL of the scope for the service worker to register
 * @returns {ServiceWorker}        Registered service worker
 */
export async function registerServiceWorker(path, options) {

	let result;

	if ('serviceWorker' in navigator) {
		try {
			result = await navigator.serviceWorker.register(path, options);
		} catch (error) {
			console.error(error);
		}
	}

	return result;

}

/**
 * Unregister a currently registered service worker
 * @returns {ServiceWorker} Unregistered service worker
 */
export async function unregisterServiceWorker() {

	let result;

	if ('serviceWorker' in navigator) {
		try {
			const registration = await navigator.serviceWorker.getRegistration();

			if (!registration) { return result; }

			result = await registration.unregister();

		 } catch (error) {
			console.error(error);
		 }
	}

	return result;

}
